export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  PRODUCT: "/product",
  CONTACT: "/contact",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  Compounding: "/compounding",
};
